<template>
    <div class="banner">
        <div class="image" ref="fit">
            <visual :src="banner" />
        </div>
    </div>
</template>

<script>
import Visual from 'gvue/src/core/Visual'

import getImage from '@/helpers/image'
import objectFit from '@/mixins/fit'

export default {
    name: 'EditionBanner',
    mixins: [objectFit],
    components: { Visual },
    props: {
        current: { type: String, required: true }
    },
    computed: {
        banner() {
            return getImage({
                type: 'visual',
                name: `edition_${this.current}_header`,
                ext: 'jpg',
                sync: true
            })
        }
    }
}
</script>

<style lang="sass" scoped>
@import ~nespresso-bi/utilities
@import ~nespresso-bi/brand/variables
.banner
    position: relative
    z-index: -1

.image
    position: absolute
    width: 100%

    img
        display: block
        height: auto
        width: 100%

+mobile
    .image
        &::after
            +fit
            content: ''
            background-image: linear-gradient(to bottom, rgba(255,255,255,0) 0%, rgba(255,255,255,1) 100%)

+desktop
    .image
        min-height: 150%
        width: calc(50vw + 8%)

        img
            position: absolute
            top: 0
            left: 0
            height: 100%
            object-fit: cover
            object-position: center center
</style>
